import $ from "jquery";

const $html = $("html");
const $body = $("body");
const $window = $(window);
const $mainMenu = $(".menu-main");
const $menuTrigger = $(".js--toggle-mainmenu");
const menuOpenClass = "main-menu--active";
const scrolledDownClass = "is--main-nav-scrolled";

const burgerClassClosed = "burger-closed";
const burgerClassOpen = "burger-open";
const burgerClassStart = "burger-start"; // prevent initial animation

const $mainMenuButton = $(".header__menu-button").addClass([
  burgerClassClosed,
  burgerClassStart,
]);

/**
 * Add menu-main--bg class to attach and load backgrounds after page has loaded
 */
$(() => {
  $mainMenu.addClass("menu-main--bg");
});

/**
 * Main menu scrolled down state
 */
$mainMenu.on("scroll", () =>
  $html.toggleClass(scrolledDownClass, $mainMenu.scrollTop() > 1),
);

/**
 * Toggle Menu
 *
 * Toggles the menuOpenClass on <body>
 *
 * Prevents <body> from being scrolled
 * while the hamburger menu is open
 */
function toggleMenu() {
  var top = $window.scrollTop();

  // Pin the body and prevent scrolling while the menu is open
  if (!$html.is("." + menuOpenClass)) {
    $body.css("top", -1 * top + "px").attr("data-scroll", top);
    $menuTrigger.attr("data-ga-label", "Open");
  }

  $html.toggleClass(menuOpenClass);
  $mainMenuButton
    .removeClass(burgerClassStart) // remove start lock
    .toggleClass(burgerClassOpen)
    .toggleClass(burgerClassClosed);

  // Scroll the body back to its initial position
  if (!$html.is("." + menuOpenClass)) {
    $("body,html").scrollTop($("body").attr("data-scroll"));
    $menuTrigger.attr("data-ga-label", "Close");
  }
}

/**
 * Hamburger button toggle the menu
 */
$menuTrigger.on("click", toggleMenu);

/**
 * ESC key toggles the menu
 */
$html.on("keyup", (e) => e.keyCode === 27 && toggleMenu());
